import { type Diagnostic, type DiagnosticRun, type DiagnosticSeverity, SEVERITY_ORDER } from "./types";

const findingsOf = (value: unknown): Diagnostic[] | undefined => {
  const diagnostics = value && typeof value === "object" ? (value as { diagnostics?: unknown }).diagnostics : undefined;
  return Array.isArray(diagnostics) && diagnostics.length ? diagnostics as Diagnostic[] : undefined;
};

/** A run that has something to say: its findings, else nothing. Anything unreadable counts as nothing. */
export const diagnosticRunWithFindings = (value: unknown): DiagnosticRun | undefined =>
  findingsOf(value) ? value as DiagnosticRun : undefined;

/**
 * A failed request's findings as a run, for the diagnostics dialog: a problem response carries only the
 * findings, so they are counted here (WaterGo's `DiagnosticsPresenter.presentError`). Nothing when it has none.
 */
export const diagnosticRunFromProblem = (body: unknown, module = "REPORT"): DiagnosticRun | undefined => {
  const diagnostics = findingsOf(body);
  if (!diagnostics) return undefined;
  const counts: Record<string, number> = {};
  for (const diagnostic of diagnostics) {
    const severity = diagnostic.core?.severity ?? "ERROR";
    counts[severity] = (counts[severity] ?? 0) + 1;
  }
  const worstSeverity = SEVERITY_ORDER.find((severity: DiagnosticSeverity) => counts[severity]) ?? "ERROR";
  return { module, blocking: true, worstSeverity, counts, diagnostics };
};
